module.exports = __webpack_public_path__ + "img/tf.e4856ed8.svg";